import { render, staticRenderFns } from "./saddleRoom.vue?vue&type=template&id=3338641c&scoped=true"
import script from "./saddleRoom.vue?vue&type=script&lang=js"
export * from "./saddleRoom.vue?vue&type=script&lang=js"
import style0 from "./saddleRoom.vue?vue&type=style&index=0&id=3338641c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3338641c",
  null
  
)

export default component.exports